/* ============================================================
   Package detail pages: photo gallery lightbox, reading
   progress bar and back-to-top button.

   The gallery markup calls openLB(n) / lbNav(d) / closeLB() from
   inline onclick attributes. Several pages pass the same index to
   every "gallery-more" tile, so each tile is re-bound to open its
   own photo rather than trusting the inline index.
   ============================================================ */
(function () {
  'use strict';

  var items = [];
  var current = 0;
  var lightbox, lbImg, lbCaption;

  function ensureLightbox() {
    lightbox = document.getElementById('lightbox');
    if (!lightbox) {
      // A few pages ship the gallery without the lightbox markup.
      lightbox = document.createElement('div');
      lightbox.className = 'lightbox';
      lightbox.id = 'lightbox';
      lightbox.innerHTML =
        '<div class="lightbox-inner">' +
          '<button class="lightbox-close" type="button" aria-label="Close"><i class="fa-solid fa-x"></i></button>' +
          '<button class="lightbox-nav lb-prev" type="button" aria-label="Previous photo"><i class="fa-solid fa-angle-left"></i></button>' +
          '<img src="" alt="" id="lbImg"/>' +
          '<button class="lightbox-nav lb-next" type="button" aria-label="Next photo"><i class="fa-solid fa-angle-right"></i></button>' +
          '<div class="lightbox-caption" id="lbCaption"></div>' +
        '</div>';
      document.body.appendChild(lightbox);
      lightbox.querySelector('.lightbox-close').addEventListener('click', closeLB);
      lightbox.querySelector('.lb-prev').addEventListener('click', function () { lbNav(-1); });
      lightbox.querySelector('.lb-next').addEventListener('click', function () { lbNav(1); });
    }
    lbImg = document.getElementById('lbImg');
    lbCaption = document.getElementById('lbCaption');
  }

  function captionFor(item) {
    var label = item.querySelector('.g-overlay span, .gallery-overlay span');
    var img = item.querySelector('img');
    return (label && label.textContent.trim()) || (img && img.alt) || '';
  }

  function show(index) {
    if (!items.length) return;
    current = (index + items.length) % items.length;
    var img = items[current].querySelector('img');
    if (!img) return;
    lbImg.src = img.currentSrc || img.src;
    lbImg.alt = img.alt || '';
    if (lbCaption) lbCaption.textContent = captionFor(items[current]);
  }

  function openLB(index) {
    if (!lightbox) return;
    show(typeof index === 'number' ? index : 0);
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLB() {
    if (!lightbox) return;
    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  function lbNav(step) {
    show(current + step);
  }

  // Inline onclick handlers in the page markup call these globals.
  window.openLB = openLB;
  window.closeLB = closeLB;
  window.lbNav = lbNav;

  function initGallery() {
    items = Array.prototype.slice.call(document.querySelectorAll('.g-item'));
    if (!items.length) return;
    ensureLightbox();

    items.forEach(function (item, i) {
      // Replaces the inline onclick, so every tile opens its own photo.
      item.onclick = function () { openLB(i); };
    });

    // Click on the dark backdrop closes; clicks inside the frame do not.
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLB();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') closeLB();
      else if (e.key === 'ArrowLeft') lbNav(-1);
      else if (e.key === 'ArrowRight') lbNav(1);
    });
  }

  function initScrollWidgets() {
    var progress = document.getElementById('readProgress');
    var backTop = document.getElementById('backTop');
    if (!progress && !backTop) return;

    var ticking = false;
    function update() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (progress) progress.style.width = (max > 0 ? (window.scrollY / max) * 100 : 0) + '%';
      if (backTop) backTop.classList.toggle('show', window.scrollY > 400);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function init() {
    initGallery();
    initScrollWidgets();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
